export default __webpack_public_path__ + "static/dont-stack-images-d5410c90c9bd9df73d99d67d20e33d8c.png";